export default function () {
    return function (input) {
        if (input) {
            var result = [], found = false;

            if (input.length) {
                result.push(input[0]);
            }

            for (var i = 0, l = input.length; i < l; i++) {

                for (var j = 0; j < result.length; j++) {

                    if (result[j].courseCode === input[i].courseCode) {
                        found = true;
                        break;
                    } else {
                        found = false;
                    }
                }

                if (!found) {
                    result.push(input[i]);
                }
            }
            return result;
        }

        return null;
    };
};